import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import { IGetBonusesResults, IGetBonusTransaction, IGetBonusTransactionsReportQuery } from "./types"

export const getBonuses = (): Promise<AxiosResponse<IGetBonusesResults>> => {
    return apiInstance.handler.get<IGetBonusesResults>(`/bonuses`)
}

export const getBonusTransaction = (id: string): Promise<AxiosResponse<IGetBonusTransaction>> => {
    return apiInstance.handler.get<IGetBonusTransaction>(`/bonuses/transactions/${id}`)
}


export const getProcessingTransactions = (page: number, limit: number, startDate: Date, endDate: Date, bonusId: string[] | null, category?: "social" | "users", withAccrual?: 'true' | 'false') => {
    return  apiInstance.handler.get(`/partners/processing-transactions`, {
        params: {
            page,
            limit,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            bonusId,
            category,
            withAccrual
        }
    })
}

export const getBonusTransactionsReportXlsx = (query: IGetBonusTransactionsReportQuery): Promise<AxiosResponse<Blob>> => {
    return apiInstance.handler.post<Blob>(`/bonuses/bonus-transactions-report/xlsx`, query, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
